<template>
  <div class="image-picker">
    <v-row v-if="title" justify="center" align="start">
      <span class="card-title-font">{{ title }}</span>
    </v-row>
    <v-row justify="center" align="start">
      <span>{{ width }} x {{ height }} (px)</span>
    </v-row>
    <v-row v-if="error" justify="center" align="start">
      <span class="error--text text-caption">{{ error }}</span>
    </v-row>
    <v-row justify="center" align="start">
      <div class="image-container">
        <img v-if="internalUrl" :src="internalUrl" :height="fixedHeight" :width="calculatedWidth" class="preview-image" />
        <div v-else class="empty-placeholder" :style="{ height: fixedHeight + 'px', width: calculatedWidth + 'px' }">
          <v-icon size="48" color="grey lighten-2">image</v-icon>
        </div>
      </div>
    </v-row>
    <v-row justify="center" align="center" class="mt-3">
      <v-btn small class="icon-button" color="primary" title="Alterar imagem" @click="resetImage">
        <v-icon>edit</v-icon>
      </v-btn>
      <v-btn v-if="internalUrl" small outlined color="primary" class="ml-2 icon-button" title="Visualizar imagem" @click="viewImage">
        <v-icon>visibility</v-icon>
      </v-btn>
      <v-btn v-if="internalUrl" small color="error" class="ml-2 icon-button" title="Remover imagem" @click="remove">
        <v-icon>delete</v-icon>
      </v-btn>
      <input id="image-input" ref="image-input" class="hidden-input" type="file" @input="readImage($event)" />
    </v-row>
    <mf-loading-dialog :loading="loading" />
  </div>
</template>

<script>
import { MUTATION_SINGLE_UPLOAD } from '@/modules/configuracoes-admin/graphql'

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    value: String,
    height: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    previewRate: {
      type: Number,
      default: 1,
    },
    label: String,
    error: String,
  },
  data: () => ({
    lazyUrl: '',
    file: null,
    loading: false,
  }),
  computed: {
    internalUrl: {
      get() {
        return this.lazyUrl
      },
      set(value) {
        this.lazyUrl = value
        this.$emit('input', value)
      },
    },
    // Fixed height based on 1920x780 reduced height (similar to the reference)
    fixedHeight() {
      return 120 // Fixed height for all images
    },
    // Calculate width maintaining aspect ratio
    calculatedWidth() {
      const aspectRatio = this.width / this.height
      return Math.round(this.fixedHeight * aspectRatio)
    },
  },
  mounted() {
    this.lazyUrl = this.value
  },
  methods: {
    remove() {
      this.internalUrl = ''
      this.file = null
    },
    resetImage() {
      this.$refs['image-input'].click()
      document.querySelector(`#image-input`).value = '' // This enables secting the same file again
    },
    viewImage() {
      if (this.internalUrl) {
        // Create a new tab with an HTML page that displays the image
        const newTab = window.open('', '_blank')
        if (newTab) {
          newTab.document.write(`
            <html>
              <head>
                <title>Visualizar Imagem</title>
                <style>
                  body { 
                    margin: 0; 
                    padding: 20px; 
                    background: #f5f5f5; 
                    display: flex; 
                    justify-content: center; 
                    align-items: center; 
                    min-height: 100vh; 
                    font-family: Arial, sans-serif;
                  }
                  img { 
                    max-width: 100%; 
                    max-height: 100vh; 
                    box-shadow: 0 4px 20px rgba(0,0,0,0.1); 
                    border-radius: 8px;
                  }
                </style>
              </head>
              <body>
                <img src="${this.internalUrl}" alt="Imagem" onload="document.title = 'Imagem - ' + this.naturalWidth + 'x' + this.naturalHeight" />
              </body>
            </html>
          `)
          newTab.document.close()
        }
      }
    },
    async readImage(event) {
      this.file = event.target.files[0]
      this.loading = true
      try {
        const { data } = await this.$apollo.mutate({
          mutation: MUTATION_SINGLE_UPLOAD,
          variables: {
            file: this.file,
            prefix: 'wl_assets/dynamic',
          },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        this.loading = false
        this.internalUrl = data.singleUpload.url
      } catch (e) {
        this.$snackbar({ message: `Falha no upload de arquivo: ${e.message}` })
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
.image-picker {
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px dashed #e0e0e0;
    border-radius: 8px;
    padding: 8px;
    background-color: #fafafa;

    .preview-image {
      object-fit: cover;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .empty-placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f5f5f5;
      border: 2px dashed #d0d0d0;
      border-radius: 4px;
    }
  }

  .hidden-input {
    display: none;
  }

  .icon-button {
    min-width: auto !important;
    padding: 0 4px !important;
  }

  .title-text {
    font-weight: 500;
    font-size: 14px;
    color: #424242;
    margin-bottom: 4px;
  }
}
</style>
